import React, { useState, useContext, useEffect } from 'react';
import { Button, Form, FormGroup, Col, Row, Label, Input, InputGroup, InputGroupAddon, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link, Route, useParams } from 'react-router-dom';
import Alert from 'react-s-alert';
import moment from 'moment';
import Joyride, { STATUS } from 'react-joyride';

// import contexts
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// import services
import ProviderService from '../../../services/ProviderService';
import AuthService from '../../../services/AuthService';
import GeneralService from '../../../services/GeneralService';
import DemoService from '../../../services/DemoService';

// local imports
import ProviderNavbar from './ProviderNavbar';
import Footer from '../../general/Footer';
import ErrorBoundary from '../../general/ErrorBoundary';
import { counsellors, profileImage1 } from '../demoData';

const ViewProviderProfile = props => {

    // contexts
    const { theme, fontSize, colors, fontFamily, fontWeight } = useContext(ThemeContext);
    const { selectedTimeZone } = useContext(AuthContext);

    // states
    const [user, setUser] = useState({ firstName: "", lastName: "", email: "", selectedRole: '', roles: [], profileImage: "", demoTakenFor: [] });
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [provider, setProvider] = useState({
        providerUniqueId: null
    })
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h2>View your profile details from here!</h2>,
                placement: 'center',
                target: '#providerProfileDiv',
            },
            {
                content: <div className="tooltipDiv">View public page of your profile by pressing here!</div>,
                placement: 'left',
                target: '#viewBtn',
            },
            {
                content: <div className="tooltipDiv">Edit your profile details by pressing here!</div>,
                placement: 'left',
                target: '#editBtn',
            }
        ]
    });
    let helpers = null;

    // variables
    const { providerUniqueId } = useParams();

    // useEffects
    useEffect(() => {
        try {
            DemoService.getUserData().then(data => {
                if (data.isAuthenticated) {
                    if (data.user.roles.includes("DemoProvider")) {
                        setUser(data.user);
                        if (!data.user.demoTakenFor.includes("ViewProviderProfile")) {
                            setTutorial({ ...tutorial, status: true });
                        }
                        setProvider({
                            ...counsellors[0],
                            specialities: counsellors[0].specialities ? counsellors[0].specialities.join(', ') : [],
                            languages: counsellors[0].languages ? counsellors[0].languages.join(', ') : [],
                            degrees: counsellors[0].degrees ? counsellors[0].degrees.join(', ') : []
                        });
                    } else {
                        // props.history.replace('PagePath');
                    }
                } else {
                    props.history.replace('/demo/signin');
                }
            })
        }
        catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderPublicPage useEffect', 'Error in try catch block', err.stack);
        }
    }, [])

    // handle functions
    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.demoTakenFor.includes("ViewProviderProfile")) {
                DemoService.markVisited("ViewProviderProfile");
                setUser({ ...user, demoTakenFor: [...user.demoTakenFor, "ViewProviderProfile"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    // function's return
    return (
        <div id="providerProfileDiv">
            <ErrorBoundary errorAt="At Provider ViewProviderProfile Joyride">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
            </ErrorBoundary>

            <ProviderNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />

            <div>
                <div className="mx-3 mt-3 row">
                    <h1 id="ViewProviderProfileText" style={theme.headingBold}>Profile</h1>

                    <Link id="viewBtn" className="ml-auto" to={`/demo/counsellors/${provider.providerUniqueId}`}>
                        <span style={{ color: colors.primary }} id="ProviderProfilePublicPage">
                            <i id="ViewProviderProfilePublicPageText" className="fas fa-eye"></i> Public Page
                        </span>
                    </Link>

                    <Link id="editBtn" to={"/demo/counsellor/profile/edit"}>
                        <span className="ml-3" style={{ color: colors.primary }} id="ProviderProfileEditText">
                            <i id="ViewProviderProfileEditText" className="fas fa-edit"></i> Edit
                        </span>
                    </Link>
                </div>

                <hr className="mx-3" style={{ borderWidth: "2px" }} />

                <div className="mt-5 row p-3">
                    <div style={{ border: "5px solid", borderRadius: "10px", borderColor: colors.primary, background: colors.primary, maxWidth: "0px", maxHeight: "100%" }}></div>
                    <div className="col-md-3 col-sm-3 col-11 py-3">
                        {/* <div style={{position: 'absolute', left: "5%", border: "5px solid", borderRadius: "10px", borderColor: colors.primary, maxWidth: "0px", minHeight: "100%"}}></div> */}
                        <div className="mx-auto text-center" style={{ width: "120px", height: "120px" }}>
                            <img id="providerProfileImg" className="m-auto w-100 h-100" src={provider.profileImage} alt="Counsellor" style={{ borderRadius: "100%", border: "solid 3px #C4C4C4" }} />
                        </div>
                    </div>

                    <div className="col-md-8 col-sm-8 col-11">
                        <h1 style={{ fontFamily: fontFamily.primary, fontSize: "2.5rem", fontWeight: fontWeight.medium }}>{provider.title} {provider.firstName} {provider.lastName}</h1>
                        <h2 style={{ fontFamily: fontFamily.primary, fontSize: "1.5rem", fontWeight: fontWeight.regular }}>Psychologist</h2>

                        <p className="mt-4" style={theme.paragraph}>
                            <i className="fas fa-map-marker-alt"></i> <span>{provider.city}, {provider.state} - {provider.country}</span>
                        </p>
                    </div>
                </div>

                <p className="float-right" ><span style={theme.paragraphHeading}>Last Updated - </span><span style={theme.paragraph}>{moment(provider.updatedAt).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).format('MMM DD, YYYY')}</span></p>

                <hr className="mt-5" />

                <div className="my-3 row p-3">

                    <div className="col-md-3 col-sm-3 col-12">
                        <p id="providerProfileEmailLabel" className="m-0" style={theme.paragraphHeading}>Email</p>
                        <p className="m-0" style={theme.paragraph}>{provider.email}</p>

                        <br />

                        <p id="providerProfileGenderLabel" className="m-0" style={theme.paragraphHeading}>Gender</p>
                        <p className="m-0" style={theme.paragraph}>{provider.gender}</p>

                        <br />

                        <p id="providerProfileLanLabel" className="m-0" style={theme.paragraphHeading}>Languages</p>
                        <p className="m-0" style={theme.paragraph}>{provider.languages}</p>

                        <br />

                        <p id="providerProfileDegreeLabel" className="m-0" style={theme.paragraphHeading}>Degree / License</p>
                        <p className="m-0" style={theme.paragraph}>{provider.degrees}</p>

                        <br />

                        <p id="providerProfileSpecLabel" className="m-0" style={theme.paragraphHeading}>Specialities</p>
                        <p className="m-0" style={theme.paragraph}>{provider.specialities}</p>

                        <br />

                        <p id="providerProfileContactLabel" className="m-0" style={theme.paragraphHeading}>Contact Number</p>
                        <p className="m-0" style={theme.paragraph}>{provider.phone}</p>

                        <br />

                    </div>

                    <div className="col-md-9 col-sm-9 col-12">
                        <h3 id="providerProfileAboutMeLabel" className="mb-3" style={{ fontFamily: fontFamily.primary, fontSize: "1.5rem", fontWeight: fontWeight.medium }}>About Me</h3>
                        <p style={{ fontFamily: fontFamily.primary, fontSize: "1.1rem" }}>{provider.description}</p>

                        <br />
                        <br />

                        <h3 id="ViewProviderProfilePublicPageLink" className="mb-3" style={{ fontFamily: fontFamily.primary, fontSize: "1.5rem", fontWeight: fontWeight.medium }}>Public Page Link</h3>
                        {
                            provider.providerIDSelected
                                ? <p style={{ fontFamily: fontFamily.primary, fontSize: "1.1rem" }}>https://www.umangwellness.com/counsellors/<span style={{ fontWeight: 600 }}>{provider.providerUniqueId}</span></p>
                                : <span style={{ color: "#FFC107" }}><i className="fas fa-exclamation-circle"></i> ID yet to setup</span>
                        }

                        <br />
                        <br />

                        <h3 id="ViewProviderProfileSocialLinks" className="mb-3" style={{ fontFamily: fontFamily.primary, fontSize: "1.5rem", fontWeight: fontWeight.medium }}>Social Links</h3>

                        {
                            provider.socialLinkFacebook
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Facebook</span> - {provider.socialLinkFacebook}
                                    <a className='ml-2' href={`https://${provider.socialLinkFacebook}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null

                        }

                        {
                            provider.socialLinkTwitter
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Twitter</span> - {provider.socialLinkTwitter}
                                    <a className='ml-2' href={`https://${provider.socialLinkTwitter}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }

                        {
                            provider.socialLinkInstagram
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Instagram</span> - {provider.socialLinkInstagram}
                                    <a className='ml-2' href={`https://${provider.socialLinkInstagram}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }

                        {
                            provider.socialLinkYoutube
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Youtube</span> - {provider.socialLinkYoutube}
                                    <a className='ml-2' href={`https://${provider.socialLinkYoutube}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }

                        {
                            provider.socialLinkQuora
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Quora</span> - {provider.socialLinkQuora}
                                    <a className='ml-2' href={`https://${provider.socialLinkQuora}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }

                        {
                            provider.socialLinkMedium
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>Medium</span> - {provider.socialLinkMedium}
                                    <a className='ml-2' href={`https://${provider.socialLinkMedium}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }

                        {
                            provider.socialLinkLinkedin
                                ?
                                <p className="mb-2" style={{ fontFamily: fontFamily.primary, fontSize: "1rem" }}>
                                    <span style={{ fontWeight: 450 }}>LinkedIn</span> - {provider.socialLinkLinkedin}
                                    <a className='ml-2' href={`https://${provider.socialLinkLinkedin}`} target="_blank"><i className="fas fa-external-link-alt" /></a>
                                </p>
                                : null
                        }


                    </div>


                </div>
            </div>
            <Footer />

        </div>
    )
}

export default ViewProviderProfile;